import { region } from '#shared/constants/firebase'

interface RuntimeConfig {
    public: {
        FIREBASE_PROJECT_ID?: string
        FIREBASE_USE_EMULATOR?: string
    }
}

/**
 * Check if we're running in production environment
 * Uses NODE_ENV from runtime config
 */
export function isProduction(): boolean {
    const config = useRuntimeConfig()
    return config.public.NODE_ENV === 'production'
}

export function getFunctionUrl(name: string, config: RuntimeConfig): string {
    const projectId = config.public?.FIREBASE_PROJECT_ID
    const isEmulator = config.public?.FIREBASE_USE_EMULATOR === 'true'

    if (isEmulator) {
        return `http://localhost:5001/${projectId}/${region}/${name}`
    }

    return `https://${region}-${projectId}.cloudfunctions.net/${name}`
}

export function getFullPathWithDomain(urlFullPathWithoutDomain: string): string {
    const isProd = isProduction()
    const config = useRuntimeConfig()

    if (isProd) {
        return 'https://growni.sk' + urlFullPathWithoutDomain
    }

    if (process.client) {
        return window.location.origin + urlFullPathWithoutDomain
    }

    const projectId = config.public?.FIREBASE_PROJECT_ID
    if (projectId) {
        return `https://${projectId}.web.app${urlFullPathWithoutDomain}`
    }

    return urlFullPathWithoutDomain
}
